'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reduxForm = require('redux-form');

var _reactBootstrap = require('react-bootstrap');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _dateFunctions = require('../../helpers/dateFunctions');

var _dateFunctions2 = _interopRequireDefault(_dateFunctions);

var _LabelledInputComponent = require('../../components/input/LabelledInputComponent');

var _LabelledInputComponent2 = _interopRequireDefault(_LabelledInputComponent);

var _SelectComponent = require('../../components/input/SelectComponent');

var _SelectComponent2 = _interopRequireDefault(_SelectComponent);

var _SectionHeaderComponent = require('../../components/common/SectionHeaderComponent');

var _SectionHeaderComponent2 = _interopRequireDefault(_SectionHeaderComponent);

var _StaticComponent = require('../../components/common/StaticComponent');

var _StaticComponent2 = _interopRequireDefault(_StaticComponent);

var _DatePickerComponent = require('../../components/input/DatePickerComponent');

var _DatePickerComponent2 = _interopRequireDefault(_DatePickerComponent);

var _TextInputComponent = require('../../components/input/TextInputComponent');

var _TextInputComponent2 = _interopRequireDefault(_TextInputComponent);

var _formConfiguration = require('../../transformers/common/formConfiguration');

var _formConfiguration2 = _interopRequireDefault(_formConfiguration);

var _application = require('../../transformers/all-inclusive/application');

var _application2 = _interopRequireDefault(_application);

var _Quote = require('../../validators/all-inclusive/Quote');

var _Quote2 = _interopRequireDefault(_Quote);

var _translate = require('../../language/translate');

var _InitialValues = require('../common/InitialValues');

var _InitialValues2 = _interopRequireDefault(_InitialValues);

var _commonFunctions = require('../../helpers/commonFunctions');

var _quote = require('../../transformers/all-inclusive/quote');

var _quote2 = _interopRequireDefault(_quote);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var fields = [].concat(_toConsumableArray((0, _commonFunctions.getBaseFields)()), _toConsumableArray((0, _commonFunctions.getApplicantDetailFields)()), ['application.additional_data.trip_booked_date', 'application.additional_data.membership_number', 'application.additional_data.province_of_residence', 'application.additional_data.trip_cancellation_coverage_limit', 'application.additional_data.policy_type', 'application.additional_data.number_of_days_per_trip', 'application.additional_data.destination', 'application.additional_data.trip_cost', 'application.additional_data.country_of_origin', 'application.additional_data.cancel_delux']);

/**
 * Renders the part of the form which generates a live quote.
 * @extends {Component}
 */

var GetQuoteComponent = function (_React$Component) {
  _inherits(GetQuoteComponent, _React$Component);

  function GetQuoteComponent(props) {
    _classCallCheck(this, GetQuoteComponent);

    var _this = _possibleConstructorReturn(this, (GetQuoteComponent.__proto__ || Object.getPrototypeOf(GetQuoteComponent)).call(this, props));

    _this.onChangeHook = _this.onChangeHook.bind(_this);
    _this.getDefaultExpiryDate = _this.getDefaultExpiryDate.bind(_this);
    _this.isMultiTrip = _this.isMultiTrip.bind(_this);
    _this.isSingleTrip = _this.isSingleTrip.bind(_this);

    _this.ageLimits = {
      maxYears: 86,
      seniorYears: null,
      maxEffDays: 546,
      maxExpDays: 29,
      seniorMaxCoverageDays: null,
      maxCoverageLength: 30
    };

    _this.state = {
      showNames: true,
      formFilled: false,
      showSaveQuote: true,
      showErrors: false,
      showModal: true,
      quotePriceFetched: false
    };
    return _this;
  }

  _createClass(GetQuoteComponent, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.formConfig = (0, _formConfiguration2.default)(this.props.formConfig)[0].fields;
      if (this.props.fields.application.additional_data.additional_applicants_number.value === '') {
        this.props.fields.application.additional_data.additional_applicants_number.onChange(_InitialValues2.default.additional_applicants_number);
      }
      if (this.props.fields.applicant.length === 0) {
        this.props.fields.applicant.addField();
      }
    }
  }, {
    key: 'onChangeHook',
    value: function onChangeHook() {
      (0, _commonFunctions.updateQuote)(this, _application2.default);
    }
  }, {
    key: 'getDefaultExpiryDate',
    value: function getDefaultExpiryDate() {
      var effDate = this.props.fields.application.effective_date.value;
      return effDate ? (0, _moment2.default)(effDate).add(364 + _dateFunctions2.default.getLeapYearDay(effDate, 364), 'days') : null;
    }
  }, {
    key: 'getMaxCoverageLength',
    value: function getMaxCoverageLength() {
      return this.ageLimits.maxCoverageLength < this.props.fields.application.additional_data.coverage_length.value;
    }
  }, {
    key: 'isMultiTrip',
    value: function isMultiTrip() {
      return this.props.fields.application.additional_data.policy_type.value === 'multi-trip annual';
    }
  }, {
    key: 'isSingleTrip',
    value: function isSingleTrip() {
      return this.props.fields.application.additional_data.policy_type.value === 'single trip';
    }
  }, {
    key: 'disableExpiryDate',
    value: function disableExpiryDate() {
      return this.isMultiTrip();
    }
  }, {
    key: 'updateProp',
    value: function updateProp(propName, value) {
      this.props.dispatch((0, _reduxForm.change)('genericis', propName, value));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      // const maxEffDays = setValueFromParam('tracking_code', 'freshtracks', 564, 364);
      (0, _quote2.default)(this);

      var dateRestrictions = _dateFunctions2.default.getDateLimits(this.props.values, this.ageLimits);

      return _react2.default.createElement(
        _reactBootstrap.Form,
        { horizontal: true, onSubmit: this.props.handleSubmit },
        (0, _commonFunctions.showErrorDiv)(this),
        (0, _commonFunctions.showPrimaryApplicantInfo)(this, dateRestrictions),
        _react2.default.createElement(_LabelledInputComponent2.default, {
          inputId: 'primaryApplicantMembershipNumber',
          inputLabel: this.formConfig.membership_number.title,
          inputComponent: _TextInputComponent2.default,
          inputComponentField: this.props.fields.application.additional_data.membership_number,
          inputComponentProps: {
            type: 'text'
          }
        }),
        (0, _commonFunctions.showCountryOfOrigin)(this),
        (0, _commonFunctions.showStateProvinceOfResidence)(this),
        (0, _commonFunctions.createAdditionalApplicantRows)(this, dateRestrictions),
        (0, _commonFunctions.showEligibilityBox)(this),
        _react2.default.createElement(_LabelledInputComponent2.default, {
          inputId: 'policyType',
          inputLabel: this.formConfig['additional_data.policy_type'].title,
          inputComponent: _SelectComponent2.default,
          inputComponentField: this.props.fields.application.additional_data.policy_type,
          inputComponentProps: {
            options: this.formConfig['additional_data.policy_type'].options,
            defaultSelected: 'single trip',
            onChangeHook: this.onChangeHook
          }
        }),
        this.isSingleTrip() && (0, _commonFunctions.showTripCost)(this),
        (0, _commonFunctions.showCancelDelux)(this),
        _react2.default.createElement(_LabelledInputComponent2.default, {
          inputId: 'datetripbooked',
          inputLabel: this.formConfig.trip_booked_date.title,
          inputComponent: _DatePickerComponent2.default,
          inputComponentField: this.props.fields.application.additional_data.trip_booked_date,
          inputComponentProps: {
            placeholderText: (0, _translate.t)('Please select a date...'),
            showYearDropdown: true,
            showMonthDropdown: true,
            onChangeHook: this.onChangeHook,
            minDate: dateRestrictions.application.tripbooked_date.min,
            maxDate: dateRestrictions.application.tripbooked_date.max
          }
        }),
        (0, _commonFunctions.effectiveDateField)(this, dateRestrictions),
        _react2.default.createElement(_LabelledInputComponent2.default, {
          inputId: 'returnDate',
          inputLabel: this.formConfig.expiry_date.title,
          inputComponent: _DatePickerComponent2.default,
          inputComponentField: this.props.fields.application.expiry_date,
          inputComponentProps: {
            placeholderText: (0, _translate.t)('Please select a date...'),
            showYearDropdown: true,
            showMonthDropdown: true,
            onChangeHook: function onChangeHook() {
              (0, _commonFunctions.changeExpiryAndCoverageLength)(_this2, 'expiry');_this2.onChangeHook();
            },
            minDate: dateRestrictions.application.expiry_date.min,
            maxDate: dateRestrictions.application.expiry_date.max,
            defaultDate: this.isMultiTrip() && dateRestrictions.application.multi_trip_expiry_date,
            disabled: this.isMultiTrip()
          }
        }),
        (0, _commonFunctions.showCoverageLength)(this),
        this.isMultiTrip() && _react2.default.createElement(_LabelledInputComponent2.default, {
          inputId: 'trip_cancellation_coverage_limit',
          inputLabel: this.formConfig['additional_data.trip_cancellation_coverage_limit'].title,
          inputComponent: _StaticComponent2.default,
          inputComponentField: this.props.fields.application.additional_data.trip_cancellation_coverage_limit,
          inputComponentProps: {
            staticValue: this.formConfig['additional_data.trip_cancellation_coverage_limit'].static_value
          }
        }) && _react2.default.createElement(_LabelledInputComponent2.default, {
          inputId: 'number_of_days_per_trip',
          inputLabel: this.formConfig['additional_data.number_of_days_per_trip'].title,
          inputComponent: _StaticComponent2.default,
          inputComponentField: this.props.fields.application.additional_data.number_of_days_per_trip,
          inputComponentProps: {
            staticValue: this.formConfig['additional_data.number_of_days_per_trip'].static_value
          }
        }),
        _react2.default.createElement(_LabelledInputComponent2.default, {
          inputId: 'destinationCountry',
          inputLabel: this.formConfig['additional_data.destination'].title,
          inputComponent: this.isMultiTrip() || this.props.fields.application.additional_data.country_of_origin.value !== 'CA' ? _StaticComponent2.default : _SelectComponent2.default,
          inputComponentField: this.props.fields.application.additional_data.destination,
          inputComponentProps: {
            options: (0, _commonFunctions.filterList)(this.formConfig['additional_data.destination'], this.props.removeDestinations),
            onChangeHook: this.onChangeHook,
            staticValue: this.isMultiTrip() && this.props.fields.application.additional_data.country_of_origin.value === 'CA' ? this.formConfig['additional_data.destination'].static_value : 'Canada'
          }
        }),
        (0, _commonFunctions.showSaveQuoteComponent)(this, _application2.default),
        (0, _commonFunctions.showModal)(this)
      );
    }
  }]);

  return GetQuoteComponent;
}(_react2.default.Component);

GetQuoteComponent.propTypes = _extends({}, _reduxForm.propTypes, {
  params: _react2.default.PropTypes.object,
  auth: _react2.default.PropTypes.object,
  application: _react2.default.PropTypes.object,
  formConfig: _react2.default.PropTypes.object,
  savedQuote: _react2.default.PropTypes.object,
  trackingCode: _react2.default.PropTypes.string
});


var mapStateToProps = function mapStateToProps(state) {
  return {
    auth: state.api.authorization,
    application: state.application,
    formConfig: state.formConfig.config,
    savedQuote: state.savedQuote.data
  };
};

exports.default = (0, _reduxForm.reduxForm)({
  form: 'genericis',
  fields: fields,
  destroyOnUnmount: false,
  touchOnBlur: false,
  validate: _Quote2.default
}, mapStateToProps)(GetQuoteComponent);


//////////////////
// WEBPACK FOOTER
// ./src/v2/containers/all-inclusive/GetQuoteContainer.jsx
// module id = 811
// module chunks = 0